import qs from 'qs'
import axios from '../index'
/**
 * @description 收藏接口
 * @author txw
 * @date 2019-08-19
 * @export
 */
export function collectProduct (params) {
  return axios.post('/user/setfav', qs.stringify(params))
}
/**
 * @description 获取当前时间戳
 * @author txw
 * @date 2019-08-21
 * @export
 */
export function getNowTime () {
  return axios.post('/product/time')
}
/**
 * @description 缺货提醒
 * @author txw
 * @date 2019-08-28
 * @param {id:1}
 * @export
 */
export function shortageRemind (params) {
  return axios.post('/user/remind-product', qs.stringify(params))
}
/**
 * @description 预订商品
 * @author txw
 * @date 2019-08-28
 * @param {id:1,num: 1}
 * @export
 */
export function bookingGoods (params) {
  return axios.post('/user/remind-product-num', qs.stringify(params))
}
/**
 * @description 区域经销
 * @author txw
 * @date 2019-08-29
 * @param {id:1}
 * @export
 */
export function exclusiveGoods (params) {
  return axios.post('/ctrlmarketing/control-goods-apply-tips', qs.stringify(params))
}
/**
 * @description 议价商品申请采购
 * @author txw
 * @date 2019-11-29
 * @param {goods_id:1,distributor_member_id:1}
 * @export
 */
export function applyShoppingSms (params) {
  return axios.post('/bargain/apply-shopping-sms', qs.stringify(params))
}
/**
 * @description 库存缺货预定和提醒(合并了)
 * @author cc
 * @date 2020-03-09
 * @param
 * @export
 */
export function remindGoods (params) {
  return axios.post('/user/remind-goods', qs.stringify(params))
}
/**
 * @description 区域经销电话号码返回
 * @author cc
 * @date 2020-03-26
 * @export
 */
export function controlGoodsApplyTips (params) {
  return axios.post('/ctrlmarketing/control-goods-apply-tips', qs.stringify(params))
}
/**
 * @description 新版加入购物车
 * @author cc
 * @date 2020-5-13
 * @export
 */
export function addtocartnew (params) {
  return axios.post('/cart/add-cart-new', qs.stringify(params))
}
